import ShimmerEffect from './ShimmerEffect';
import Rect from './Rect';
import Circle from './Circle';
import NoAnimationBox from './NoAnimationContainer';
// TODO: check with designer if we need variants instead of passing all those css props.
export default { ShimmerEffect: ShimmerEffect, Rect: Rect, Circle: Circle, NoAnimationBox: NoAnimationBox };
